import { useQuery } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';

const PATH = 'api/landlord/rentmanager-integration';

export interface IRentManagerIntegration {
    username: string | null;
    is_enabled: boolean;
}

export const useRentManagerIntegration = (options?: { disabled?: boolean }) => {
    return useQuery(
        [queryKeys.rentManagerIntegration],
        async () => apiClient(PATH).json<IRentManagerIntegration>(),
        { enabled: !options?.disabled }
    );
};
